// jQuery(document).ready(function($) {
//   if ($("main.recent-success").length) {
//     console.log("Recent Success Page");

//     var ppp = 8; // Post per page
//     var pageNumber = 1;

//     /********************************
//      *  NEW Filter 2020 *************
//      ********************************/
//     $(".buttons button").click(function(e) {
//       if ($(this).hasClass("grid")) {
//         if (!$(this).hasClass("active")) {
//           $(".list").removeClass("active");
//           $(this).addClass("active");
//         }
//         $(".filtercontainer")
//           .removeClass("list")
//           .addClass("grid");
//       } else if ($(this).hasClass("list")) {
//         if (!$(this).hasClass("active")) {
//           $(".grid").removeClass("active");
//           $(this).addClass("active");
//         }
//         $(".filtercontainer")
//           .removeClass("grid")
//           .addClass("list");
//       }
//     });

//     // Sticky Filter Menu for OTM Page Mobile
//     function stickyFilterOtm() {
//       var filterCtrls = $(".filter-controls"),
//         marginHeight = filterCtrls.outerHeight(),
//         stickyTop = filterCtrls.offset().top,
//         otmContainer = $("main.on-the-market");
//       //console.log(marginHeight);
//       $(window).on("scroll", function() {
//         if (window.innerWidth < 950) {
//           if ($(window).scrollTop() >= stickyTop) {
//             filterCtrls.css({ position: "fixed", top: "0px", zIndex: "999" });
//             otmContainer.css({ marginTop: marginHeight + "px" });
//           } else {
//             filterCtrls.css({ position: "relative", zIndex: "initial" });
//             otmContainer.css({ marginTop: "0" });
//           }
//         } else {
//           filterCtrls.css({ position: "relative", zIndex: "initial" });
//           otmContainer.css({ marginTop: "0" });
//         }
//       });
//     }
//     stickyFilterOtm();
//     $(window).on("resize", stickyFilterOtm);

//     // Mobile Filter Reveal
//     var filterSelectBtn = $(".filter-selects-btn"),
//       btnsInput = $(".btns-input"),
//       btnsInputBtn = $(".btns-input button"),
//       btnText = btnsInputBtn.text().toLowerCase();

//     $(".filter-selects-btn button").on("click ", function() {
//       if (!filterSelectBtn.hasClass("open-filter")) {
//         var btnTextScoped = btnsInputBtn.text().toLowerCase();

//         filterSelectBtn.toggleClass("open-filter");
//         btnsInput.toggleClass("close-btn");

//         btnsInputBtn.removeClass("grid list").attr("data-text", btnTextScoped);
//         btnsInputBtn.text(function(i, text) {
//           //console.log(text);
//           return text === text ? "" : text;
//         });

//         $(".filter-selects").toggleClass("show");
//       }
//     });

//     $(".filter-selects-btn.open-filter button").on("click", function(e) {
//       e.preventDefault();
//     });

//     $(".btns-input button").on("click", function() {
//       if ($(".btns-input").hasClass("close-btn")) {
//         var btntext = $(".btns-input button").attr("data-text");
//         filterSelectBtn.removeClass("open-filter");
//         btnsInput.removeClass("close-btn");
//         btnsInputBtn.text(btntext);
//         setTimeout(function() {
//           $(".btns-input button").addClass(btnText);
//         }, 100);

//         $(".filter-selects").toggleClass("show");
//       }
//     });

//     // Toggle Button Switch between Grid / List views
//     $(".btns-input button").click(function() {
//       if ($(this).hasClass("grid")) {
//         $(this).removeClass("grid");
//         $(this)
//           .addClass("list")
//           .text("List");
//         $(".filtercontainer")
//           .removeClass("grid")
//           .addClass("list");
//       } else if ($(this).hasClass("list")) {
//         $(this).removeClass("list");
//         $(this)
//           .addClass("grid")
//           .text("Grid");
//         $(".filtercontainer")
//           .removeClass("list")
//           .addClass("grid");
//       }
//     });

//     /// Select2 Styling for Dropdowns
//     var filterSelects = $(".filter-controls select");
//     var selectConfig = {
//       minimumResultsForSearch: Infinity,
//       dropdownCssClass: "dropdown-custom",
//       width: "style",
//       //closeOnSelect: false,
//       dropdownParent: $(".filter-selects")
//     };

//     function runSelect2() {
//       filterSelects.select2(selectConfig);
//     }

//     if (window.innerWidth >= 950) {
//       runSelect2();
//     }

//     $(window).on("resize", function() {
//       if (this.innerWidth >= 950) {
//         runSelect2();
//       } else {
//         if (filterSelects.data("select2")) {
//           filterSelects.select2("destroy");
//         }
//       }
//     });

//     // Select Input Ajax
//     $(".filter-controls select").change(function() {
//       var cityVal = $(this).val(),
//         loadMoreBtn = $("#more_posts"),
//         auctionDate = $(".date-select option:selected:not([disabled])").val(),
//         stateAbbr = $(".state-select option:selected:not([disabled])").val(),
//         cityTitle = $(".cities-select option:selected:not([disabled])").val(),
//         data = {
//           action: "otmFilter",
//           auc_date: auctionDate,
//           state: stateAbbr,
//           city: cityTitle,
//           page: 1,
//           template: "recent-success-page"
//         };
//       $.ajax({
//         // you can also use $.post here
//         url: loadmore_params.ajaxurl, // AJAX handler
//         data: data,
//         type: "POST",
//         beforeSend: function() {
//           $("#prop-num").removeClass("active");
//         },
//         success: function(data) {
//           //console.log(data);
//           if (data) {
//             $("#filterContainer")
//               .empty()
//               .append(data);
//           } else {
//             //button.hide(); // if no data, remove the button as well
//             $(".load-more-container").append(
//               '<p class="no-mas lead">No more results.</p>'
//             );
//           }
//           loadMoreBtn.removeAttr("disabled");
//           $(".load-more.loading-dots").hide();
//         },
//         complete: function() {
//           $("#prop-num")
//             .addClass("active")
//             .text(postNum);
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//           // console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
//         }
//       });
//     });

//     // Search Input Ajax
//     function delay(callback, ms) {
//       var timer = 0;

//       return function() {
//         var context = this,
//           args = arguments;

//         clearTimeout(timer);

//         timer = setTimeout(function() {
//           callback.apply(context, args);
//         }, ms || 0);
//       };
//     }
//     $(".filter-controls #keyword").on(
//       "keyup input",
//       delay(function(e) {
//         var loadMoreBtn = $("#more_posts");
//         data = {
//           action: "data_fetch",
//           keyword: $("#keyword").val()
//         };
//         $.ajax({
//           url: loadmore_params.ajaxurl,
//           type: "POST",
//           data: data,
//           beforeSend: function() {
//             $("#prop-num").removeClass("active");
//           },
//           success: function(data) {
//             if (data) {
//               $("#filterContainer")
//                 .empty()
//                 .append(data);
//               loadMoreBtn.attr("disabled", "disabled");
//             }
//           },
//           complete: function() {
//             $("#prop-num")
//               .addClass("active")
//               .text(postNum);
//           }
//         });
//       }, 500)
//     );

//     // Load More button Ajax
//     $("#more_posts").click(function(e) {
//       //console.log(e);
//       e.preventDefault();
//       var button = $(this),
//         cityTitle = $(".cities-select option:selected").text(),
//         data = {
//           action: "loadmore",
//           page: pageNumber,
//           city: cityTitle
//         };

//       $.ajax({
//         // you can also use $.post here
//         url: loadmore_params.ajaxurl, // AJAX handler
//         data: data,
//         type: "POST",
//         beforeSend: function(xhr) {
//           //console.log(xhr);
//         },
//         success: function(data) {
//           // console.log(data);
//           if (data) {
//             $("#filterContainer").append(data);
//             pageNumber++;
//             //console.log(pageNumber);

//             button.show();

//             // if (loadmore_params.current_page == loadmore_params.max_page) {
//             //   button.hide(); // if last page, remove the button
//             // }
//           } else {
//             //button.hide(); // if no data, remove the button as well
//             $("#filterContainer").append(
//               '<p class="no-mas lead">No more results.</p>'
//             );
//             button.attr("disabled", "disabled");
//           }

//           //$(".load-more.loading-dots").hide();
//         },
//         error: function(jqXHR, textStatus, errorThrown) {
//           //$("#image").hide();
//           // console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
//         }
//       });
//     });
//   }
// });
